import React from 'react';
import { CheckCircle } from 'lucide-react';
import { tiers } from '../data/content';

const PricingSection = () => {
  return (
    <section id="pricing" className="py-20 px-4 sm:px-6 lg:px-8 bg-slate-800/30">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-white mb-6">Choose Your Evolution Tier</h2>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto">
            From individual developers to enterprise teams, scale your AI orchestration as you grow.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {tiers.map((tier, index) => (
            <div key={index} className={`relative bg-slate-800 border rounded-2xl p-8 transition-all duration-200 hover:scale-105 ${
              tier.popular ? 'border-blue-500 ring-2 ring-blue-500/20 shadow-2xl' : 'border-slate-700 hover:border-slate-600'
            }`}>
              {tier.popular && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                  <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-6 py-2 rounded-full text-sm font-medium shadow-lg">
                    Most Popular
                  </div>
                </div>
              )}
              
              <div className="text-center mb-8">
                <h3 className="text-2xl font-bold text-white mb-2">{tier.name}</h3>
                <div className="text-4xl font-bold text-white mb-2">
                  {tier.price}
                  {tier.price !== 'Custom' && <span className="text-lg text-slate-400">/month</span>}
                </div>
                <p className="text-slate-300 text-sm leading-relaxed">{tier.description}</p>
              </div>

              <ul className="space-y-4 mb-8">
                {tier.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-start space-x-3">
                    <CheckCircle className="h-5 w-5 text-green-500 flex-shrink-0 mt-0.5" />
                    <span className="text-slate-300 text-sm leading-relaxed">{feature}</span>
                  </li>
                ))}
              </ul>

              <button className={`w-full py-3 px-6 rounded-xl font-semibold transition-all duration-200 ${
                tier.popular
                  ? 'bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white shadow-lg hover:shadow-xl transform hover:scale-105'
                  : 'bg-slate-700 hover:bg-slate-600 text-white'
              }`}>
                {tier.cta}
              </button>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-slate-400 text-sm mb-4">
            All plans include our core AI agent framework and 24/7 evolution monitoring
          </p>
          <p className="text-slate-500 text-xs">
            Enterprise pricing includes custom SLAs, dedicated support, and white-label options
          </p>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
